import React, { useState, useEffect } from "react";
import Header from "../../../Pdf/PrintHeaderAccount";
import axios from "axios";
import config from "../../../config";
import { saleReportStyles } from "../../../Pdf/pdfStyles";
import PrintFooter from "../../../Pdf/PrintFooter";
import {
  PDFViewer,
  Page,
  Text,
  View,
  Document,
} from "@react-pdf/renderer";
import { Spin } from "antd";
import moment from "moment";
import {
  PrintFormateNumber,
  parseReportAmount,
} from "../../../Pdf/PrintFormateNumber";

function getExpenseAccountSide(entry) {
  if (!entry) return null;
  const debitType = entry?.Debit_Account?.Account_Type_BE?.ID;
  const creditType = entry?.Credit_Account?.Account_Type_BE?.ID;
  if (debitType === 8) {
    return {
      id: entry.Debit_Account_ID,
      name: entry.Debit_Account?.Name || "Expense",
    };
  }
  if (creditType === 8) {
    return {
      id: entry.Credit_Account_ID,
      name: entry.Credit_Account?.Name || "Expense",
    };
  }
  return null;
}

const ACCOUNT_COL = {
  sr: 26,
  dated: 52,
  debit: 110,
  credit: 110,
  description: 211,
  amount: 58,
};

const DATE_COL = {
  sr: 26,
  dated: 483,
  amount: 58,
};

const SUMMARY_COL = {
  sr: 26,
  account: 483,
  amount: 58,
};

function PrintExpensReport() {
  const [loading, setLoading] = useState(false);
  const UserID = localStorage.getItem("ID");
  const AccessKey = localStorage.getItem("AccessKey");

  const urlParams = new URLSearchParams(window.location.search);
  const StartDate = urlParams.get("StartDate");
  const EndDate = urlParams.get("EndDate");
  const ReportType = urlParams.get("ReportType") || "Account Wise";
  const isAccountWise = ReportType === "Account Wise";

  const [dateWiseReport, setDateWiseReport] = useState([]);
  const [accountWise, setAccountWise] = useState([]);
  const [expenseAccountSums, setExpenseAccountSums] = useState([]);
  const [expensReport, setExpensReport] = useState({});

  useEffect(() => {
    document.title = "Print Expense Report";
    if (!StartDate || !EndDate || !UserID || !AccessKey) {
      setLoading(false);
      return;
    }

    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "Report/GetExpenseReport",
      headers: { "Content-Type": "application/json" },
      data: {
        UserID,
        AccessKey,
        StartDate: moment(StartDate).isValid()
          ? moment(StartDate).format("YYYY-MM-DD")
          : StartDate,
        EndDate: moment(EndDate).isValid()
          ? moment(EndDate).format("YYYY-MM-DD")
          : EndDate,
        ReportType,
      },
    })
      .then(function (response) {
        if (response.data.status_code == 1) {
          setExpensReport(response.data);
          setAccountWise(response.data.ListofVouchers || []);
          setDateWiseReport(response.data.ListofExpenseVouchers || []);
        } else {
          setExpensReport({});
          setAccountWise([]);
          setDateWiseReport([]);
        }
      })
      .catch(function () {
        setExpensReport({});
        setAccountWise([]);
        setDateWiseReport([]);
      })
      .finally(function () {
        setLoading(false);
      });
  }, [StartDate, EndDate, UserID, AccessKey, ReportType]);

  useEffect(() => {
    const sums = {};
    (accountWise || []).forEach((entry) => {
      const side = getExpenseAccountSide(entry);
      if (!side) return;
      const amount = Number(entry.Amount) || 0;
      if (sums[side.id]) {
        sums[side.id].sum += amount;
      } else {
        sums[side.id] = { name: side.name, sum: amount };
      }
    });
    setExpenseAccountSums(Object.values(sums));
  }, [accountWise]);

  const periodLabel = `${
    StartDate && moment(StartDate).isValid()
      ? moment(StartDate).format(config.date_format)
      : "—"
  } to ${
    EndDate && moment(EndDate).isValid()
      ? moment(EndDate).format(config.date_format)
      : "—"
  }`;

  const fmt = (val) => PrintFormateNumber(parseReportAmount(val), 0);

  const totalExpense = fmt(expensReport.TotalExpenses);

  const renderAccountWiseRows = () =>
    accountWise.map((item, index) => (
      <View key={item.ID || index} style={saleReportStyles.row}>
        <View style={[saleReportStyles.td, { width: ACCOUNT_COL.sr }]}>
          <Text style={saleReportStyles.tdValue}>{index + 1}</Text>
        </View>
        <View style={[saleReportStyles.td, { width: ACCOUNT_COL.dated }]}>
          <Text style={saleReportStyles.tdValue}>
            {item.Dated
              ? moment(item.Dated).format(config.date_format)
              : "-"}
          </Text>
        </View>
        <View style={[saleReportStyles.td, { width: ACCOUNT_COL.debit }]}>
          <Text style={saleReportStyles.tdValue}>
            {item.Debit_Account?.Name || "-"}
          </Text>
        </View>
        <View style={[saleReportStyles.td, { width: ACCOUNT_COL.credit }]}>
          <Text style={saleReportStyles.tdValue}>
            {item.Credit_Account?.Name || "-"}
          </Text>
        </View>
        <View style={[saleReportStyles.td, { width: ACCOUNT_COL.description }]}>
          <Text style={saleReportStyles.tdValue}>
            {item.Description || "-"}
          </Text>
        </View>
        <View
          style={[
            saleReportStyles.td,
            { width: ACCOUNT_COL.amount, textAlign: "right" },
          ]}
        >
          <Text style={saleReportStyles.tdValue}>{fmt(item.Amount)}</Text>
        </View>
      </View>
    ));

  const renderDateWiseRows = () =>
    dateWiseReport.map((item, index) => (
      <View key={index} style={saleReportStyles.row}>
        <View style={[saleReportStyles.td, { width: DATE_COL.sr }]}>
          <Text style={saleReportStyles.tdValue}>{index + 1}</Text>
        </View>
        <View style={[saleReportStyles.td, { width: DATE_COL.dated }]}>
          <Text style={saleReportStyles.tdValue}>
            {item.Dated
              ? moment(item.Dated).format(config.date_format)
              : "-"}
          </Text>
        </View>
        <View
          style={[
            saleReportStyles.td,
            { width: DATE_COL.amount, textAlign: "right" },
          ]}
        >
          <Text style={saleReportStyles.tdValue}>{fmt(item.Amount)}</Text>
        </View>
      </View>
    ));

  const renderSummaryRows = () =>
    expenseAccountSums.map((item, index) => (
      <View key={index} style={saleReportStyles.row}>
        <View style={[saleReportStyles.td, { width: SUMMARY_COL.sr }]}>
          <Text style={saleReportStyles.tdValue}>{index + 1}</Text>
        </View>
        <View style={[saleReportStyles.td, { width: SUMMARY_COL.account }]}>
          <Text style={saleReportStyles.tdValue}>{item.name}</Text>
        </View>
        <View
          style={[
            saleReportStyles.td,
            { width: SUMMARY_COL.amount, textAlign: "right" },
          ]}
        >
          <Text style={saleReportStyles.tdValue}>{fmt(item.sum)}</Text>
        </View>
      </View>
    ));

  const TotalRow = ({ labelCol, amountCol, labelWidth, amountWidth }) => (
    <View style={saleReportStyles.totalsRow}>
      <View
        style={[
          saleReportStyles.th,
          { width: labelWidth, textAlign: "right" },
        ]}
      >
        <Text style={saleReportStyles.thValue}>{labelCol}</Text>
      </View>
      <View
        style={[
          saleReportStyles.th,
          { width: amountWidth, textAlign: "right" },
        ]}
      >
        <Text style={saleReportStyles.thValue}>{amountCol}</Text>
      </View>
    </View>
  );

  const MyDocument = () => (
    <Document>
      <Page size="A4" style={saleReportStyles.page}>
        <Header compact />
        <View style={saleReportStyles.section}>
          <View style={saleReportStyles.titleBlock}>
            <Text style={saleReportStyles.pagetitle}>Expense Report</Text>
            <Text style={saleReportStyles.reportSubtitle}>
              Period: {periodLabel}
            </Text>
            <Text style={saleReportStyles.reportSubtitle}>
              Report type: {ReportType}
            </Text>
          </View>

          <View style={saleReportStyles.table}>
            {isAccountWise ? (
              <>
                <View style={saleReportStyles.tableHead}>
                  <View style={[saleReportStyles.th, { width: ACCOUNT_COL.sr }]}>
                    <Text style={saleReportStyles.thValue}>Sr.</Text>
                  </View>
                  <View
                    style={[saleReportStyles.th, { width: ACCOUNT_COL.dated }]}
                  >
                    <Text style={saleReportStyles.thValue}>Date</Text>
                  </View>
                  <View
                    style={[saleReportStyles.th, { width: ACCOUNT_COL.debit }]}
                  >
                    <Text style={saleReportStyles.thValue}>Debit Account</Text>
                  </View>
                  <View
                    style={[saleReportStyles.th, { width: ACCOUNT_COL.credit }]}
                  >
                    <Text style={saleReportStyles.thValue}>
                      Credit Account
                    </Text>
                  </View>
                  <View
                    style={[
                      saleReportStyles.th,
                      { width: ACCOUNT_COL.description },
                    ]}
                  >
                    <Text style={saleReportStyles.thValue}>Description</Text>
                  </View>
                  <View
                    style={[
                      saleReportStyles.th,
                      { width: ACCOUNT_COL.amount, textAlign: "right" },
                    ]}
                  >
                    <Text style={saleReportStyles.thValue}>Amount</Text>
                  </View>
                </View>
                {renderAccountWiseRows()}
                <TotalRow
                  labelCol="Total Expense"
                  amountCol={totalExpense}
                  labelWidth={
                    ACCOUNT_COL.sr +
                    ACCOUNT_COL.dated +
                    ACCOUNT_COL.debit +
                    ACCOUNT_COL.credit +
                    ACCOUNT_COL.description
                  }
                  amountWidth={ACCOUNT_COL.amount}
                />
              </>
            ) : (
              <>
                <View style={saleReportStyles.tableHead}>
                  <View style={[saleReportStyles.th, { width: DATE_COL.sr }]}>
                    <Text style={saleReportStyles.thValue}>Sr.</Text>
                  </View>
                  <View
                    style={[saleReportStyles.th, { width: DATE_COL.dated }]}
                  >
                    <Text style={saleReportStyles.thValue}>Date</Text>
                  </View>
                  <View
                    style={[
                      saleReportStyles.th,
                      { width: DATE_COL.amount, textAlign: "right" },
                    ]}
                  >
                    <Text style={saleReportStyles.thValue}>Amount</Text>
                  </View>
                </View>
                {renderDateWiseRows()}
                <TotalRow
                  labelCol="Total Expense"
                  amountCol={totalExpense}
                  labelWidth={DATE_COL.sr + DATE_COL.dated}
                  amountWidth={DATE_COL.amount}
                />
              </>
            )}
          </View>

          <View style={[saleReportStyles.titleBlock, { marginTop: 10 }]}>
            <Text style={saleReportStyles.pagetitle}>Expense by Account</Text>
          </View>

          <View style={saleReportStyles.table}>
            <View style={saleReportStyles.tableHead}>
              <View style={[saleReportStyles.th, { width: SUMMARY_COL.sr }]}>
                <Text style={saleReportStyles.thValue}>Sr.</Text>
              </View>
              <View
                style={[saleReportStyles.th, { width: SUMMARY_COL.account }]}
              >
                <Text style={saleReportStyles.thValue}>Expense Account</Text>
              </View>
              <View
                style={[
                  saleReportStyles.th,
                  { width: SUMMARY_COL.amount, textAlign: "right" },
                ]}
              >
                <Text style={saleReportStyles.thValue}>Amount</Text>
              </View>
            </View>
            {renderSummaryRows()}
            <TotalRow
              labelCol="Total Expense"
              amountCol={totalExpense}
              labelWidth={SUMMARY_COL.sr + SUMMARY_COL.account}
              amountWidth={SUMMARY_COL.amount}
            />
          </View>

          <View
            style={{ marginBottom: 20, marginTop: 0, top: 6, bottom: 6 }}
            fixed
          >
            <Text
              style={{ fontSize: "7pt", color: "#000" }}
              render={({ pageNumber, totalPages }) =>
                `Page ${pageNumber} / ${totalPages}`
              }
            />
          </View>
        </View>
        <PrintFooter fixed />
      </Page>
    </Document>
  );

  return (
    <div style={{ width: "100%", height: "100vh", overflow: "hidden" }}>
      {loading ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        <PDFViewer width="100%" height="100%" fileName="ExpenseReport.pdf">
          <MyDocument />
        </PDFViewer>
      )}
    </div>
  );
}

export default PrintExpensReport;
